<style scoped>
    .font36{
        font-size: 36px;
    }
    .reportTab{
        overflow: hidden;
    }
    .reportTab .ivu-tabs{
        overflow: visible !important;
        z-index: 1000;
    }
    .reportTop{
        color: white;
        height: 150px;
    }
    .reportTop p{
        height: 80px;
        line-height: 80px;
    }
    .riskErr{
        color:red;
    }
    .riskErr .riskErrIcon{
        position: absolute;
        left: -40px;
        top: 8px;
    }
    .blue{
        background:linear-gradient( #23D4D7, #4FD3D5) center top no-repeat;
    }
    .yellow {
        background: linear-gradient(#d5d34f, #d7b323) center top no-repeat;
    }
    .red  {
        background: linear-gradient(#d5714f, #d73d23) center top no-repeat;
    }
</style>
<template>
    <div class="reportTab">
        <div v-if="noDate">
            <div :class="['reportTop center p-10', score >= 80 ? 'blue' : score < 60 ? 'red' : 'yellow']">
                <div class="textLeft font26 m-l-50">智慧消防分析报告</div>
                <p class="numberfont displayIB m-b-10">{{score}}</p>
                <div><span class="font18 displayIB" style="margin-right: 200px">{{depName}}</span><span class="font18 displayIB">统计时间：{{recordDate}}</span></div>
            </div>
            <div class="reportCenter p-5 textLeft" style="width: 60%; margin: 0 auto">
                <p class="m-b-10 font22">01单位监测设备完善情况</p>
                <div style="display: flex;justify-content: space-between;">
                    <div span="4" class="center" v-for="(item, index) in condition" :key="index">
                        <img :src="item.src" alt="" style="width:50px;margin: 0 auto">
                        <p :class="['font14', item.deviceCounts == 0 ? 'colorGrey' : '']">{{item.name}}</p>
                        <p class="font12 colorPrimary">{{item.deviceCount}}</p>
                    </div>
                </div>
            </div>
            <div class="reportCenter p-5 textLeft"  style="width: 60%; margin: 0 auto">
                <div span="24 font14 riskErr positionRL m-b-10" style="color: red; position: relative;" v-for="(item, index) in markedWords" :key="index">
                    <img :src="ios_outline" class="riskErrIcon" v-if="markedWords.length > 0" alt="" style="position: absolute;left: -42px;top: 50%;transform: translateY(-50%);width: 35px;">
                    <div>
                        <p class="font14">{{item.hint}}</p>
                        <p class="font14">{{item.hintB}}</p>
                    </div>
                </div>
            </div>
            <div class="reportCenter p-5 textLeft"  style="width: 60%; margin: 0 auto">
                <p class="m-b-10 font22">02单位监测设备监测分析</p>
                <div span="24" class="overHidden m-b-5" v-for="(item, index) in analyze" :key="index">
                    <img :src="item.src" alt="" class="fLeft" style="width: 50px;">
                    <div class="fLeft m-l-10" style="width: 390px;">
                        <p class="font14" v-if='item.name != "消防巡检"'>{{item.name}}监测设备报警数量 <span class="colorPrimary">{{item.alarmCount}}</span> 条，处理 <span class="colorPrimary">{{item.alarmProcessed}}</span> 条，处理中 <span class="colorPrimary">{{item.alarmProcessing}}</span> 条，未处理 <span class="riskErr">{{item.alarmUnhandledCount}}</span> 条。</p>
                        <p class="font14" v-else-if='item.name == "消防巡检"'>{{item.name}}监测设备任务执行率不合格次数 <span class="colorPrimary">{{item.failedCount}}</span> 次，隐患数量 <span class="colorPrimary">{{item.hiddenDangerCount}}</span> 条，处理 <span class="colorPrimary">{{item.hiddenDangerProcessed}}</span> 条，处理中 <span class="colorPrimary">{{item.hiddenDangerProcessing}}</span> 条，未处理 <span class="riskErr">{{item.hiddenDangerUnhandledCount}}</span> 条。</p>
                        <!--消防巡检监测设备任务执行率不合格次数 1 次，隐患数量 3 条，处理 3 条，处理中 0 条，未处理 0 条 。-->
                        <p :class="['font12 ', item.showErr ? 'riskErr' : '']">{{item.reminder}}</p>
                        <!--<p class="font14 m-t-10 m-b-10" :class="" v-if="item.showErr">{{item.reminder}}</p>-->
                        <p class="font12" v-if='item.name != "消防巡检"'>环比上{{date}}报警数量{{item.con}} <span :class="[item.showErr1 ? 'riskErr' : 'colorPrimary']">{{item.alarmChainIncreaseCount}}</span> 条。 </p>
                        <p class="font12" v-else-if='item.name == "消防巡检"'>环比上{{date}}隐患数量{{item.con}} <span :class="[item.showErr1 ? 'riskErr' : 'colorPrimary']">{{item.hiddenDangerChainIncreaseCount}}</span> 条。 </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle center" style="width: 50%;" v-else>
            <img style="vertical-align: middle;" src="@/assets/images/riskReport/zanwu.png" alt="">
            <p class="m-t-50 font16">未查询到数据...</p>
        </div>
    </div>
</template>

<script>
    import ios_outline from '@/assets/img/ios-outline.png';
    import {getDate} from '@/assets/js/tools';
    import '@/assets/icons/numberfont.css';
    import '@/assets/css/normal.css'
    // 随机字符串
    import getRandVal from '@/assets/js/index'
    // 加密
    import Base64 from '@/assets/js/base64.js'
    import md5 from 'js-md5'
    import CryptoJS from '@/assets/js/core.js'
    var SHA256 = require('../assets/js/sha256.js');
    import { risk_report } from '@/assets/js/url.js';
    export default {
        name: "risk-report",
        data() {
            return {
                time: undefined,
                score: 0,
                recordDate: '',
                depName: '',
                condition: [], //完善情况
                markedWords: [], //错误语
                analyze: [], //分析
                date: '',
                noDate: false,
                hashValue: '',
                loginData: '',
                ios_outline: ios_outline
            }
        },
        props: [
            "reportData"
        ],
        watch:{
            reportData(res){
                this.getList(res);
            }
        },
        mounted() {
            this.hashValue = window.localStorage.getItem('hashValue');
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));

        },
        methods: {
            //获取数据开始
            getPwdHash(pwd, data){
            var sha = md5(pwd + data);
            var base = new Base64();
            var pwdHashStr = base.encode(sha);
            // console.log(pwdHashStr);
            return pwdHashStr;
            },
            getList(data) {
                console.log(data);
                this.condition = [];
                this.markedWords = [];
                this.analyze = [];
                var _data = {
                    type: 'get',
                    url: risk_report,
                    obj: {
                        date: data.time,
                        orgId: data.id,
                    }
                };
                
                this.$Axios(_data).then((data) => {
                    console.log('弹窗数据');
                    let res = data.data.data;
                    if (res) {
                        if(Object.keys(res).length > 0){
                            this.noDate = true;
                            this.score = res.score;
                            this.recordDate = res.recordDate;
                            this.depName = res.depName;
                            res.type == "week" ? this.date = "周" : this.date = "月";
                            for(var i in res){
                                if(i == 'firePatrol'){ //消防巡检
                                    var obj = {},obj1 = {},obj2 = {};
                                    obj.deviceCount = `${res[i].deviceCount}次`;
                                    obj.deviceCounts = res[i].deviceCount;
                                    obj.name = obj2.name = "消防巡检";
                                    obj.id = obj1.id = obj2.id = 4;
                                    if(res[i].deviceCount == "0"){
                                        obj.src = require("@/assets/images/riskReport/xc_off.png");
                                        obj1.hint = '消防巡检监测设备未安装';
                                        obj1.hintB = '无法对单位消防安全巡查情况进行监管，建议根据现场情况加装消防巡检监测设备';
                                        this.markedWords.push(obj1);
                                    }else{
                                        obj.src = obj2.src = require("@/assets/images/riskReport/xc_nor.png");
                                        if(res[i].failedCount <= 2  && res[i].hiddenDangerUnhandledCount <= 5){
                                            obj2.reminder = "消防安全巡查人员工作执行状况良好。"
                                        }else{
                                            obj2.reminder = "消防安全巡查人员工作执行状况较差，请单位组织监督，加强安全工作监管。"
                                            obj2.showErr = true;
                                        }
                                        obj2.failedCount = res[i].failedCount;
                                        obj2.hiddenDangerCount = res[i].hiddenDangerCount;
                                        obj2.hiddenDangerProcessed = res[i].hiddenDangerProcessed;
                                        obj2.hiddenDangerProcessing = res[i].hiddenDangerProcessing;
                                        obj2.hiddenDangerUnhandledCount = res[i].hiddenDangerUnhandledCount;
                                        if(res[i].hiddenDangerChainIncreaseCount > 0){
                                            obj2.showErr1 = true;
                                            obj2.con = '增长';
                                        }else{
                                            obj2.con = '下降';
                                        }
                                        obj2.hiddenDangerChainIncreaseCount = Math.abs(res[i].hiddenDangerChainIncreaseCount);
                                        this.analyze.push(obj2);
                                    }
                                    this.condition.push(obj);
                                }else if(i == 'camera'){ //视频监控
                                    var obj = {},obj1 = {},obj2 = {};
                                    obj.deviceCount = `${res[i].deviceCount}套`;
                                    obj.deviceCounts = res[i].deviceCount;
                                    obj.name = obj2.name = "视频监控";
                                    obj.id = obj1.id = obj2.id = 3;
                                    if(res[i].deviceCount == "0"){
                                        obj.src = require("@/assets/images/riskReport/ks_off.png");
                                        obj1.hint = '视频监控设备未安装';
                                        obj1.hintB = '无法对单位监控人员在岗情况进行监管，建议根据现场情况加装视频监控';
                                        this.markedWords.push(obj1);
                                    }else{
                                        obj.src = obj2.src = require("@/assets/images/riskReport/ks_nor.png");
                                        if(res[i].alarmCount <= 10 && res[i].alarmUnhandledCount <= 3){
                                            obj2.reminder = "消控室人员工作状况良好。"
                                        }else{
                                            obj2.reminder = "消控室人员工作状况较差，请单位组织监督，加强安全工作监管。"
                                            obj2.showErr = true;
                                        }
                                        obj2.alarmCount = res[i].alarmCount;
                                        obj2.alarmProcessed = res[i].alarmProcessed;
                                        obj2.alarmProcessing = res[i].alarmProcessing;
                                        obj2.alarmUnhandledCount = res[i].alarmUnhandledCount;
                                        if(res[i].alarmChainIncreaseCount > 0){
                                            obj2.showErr1 = true;
                                            obj2.con = '增长';
                                        }else{
                                            obj2.con = '下降';
                                        }
                                        obj2.alarmChainIncreaseCount = Math.abs(res[i].alarmChainIncreaseCount);
                                        this.analyze.push(obj2);
                                    }
                                    this.condition.push(obj);
                                }else if(i == 'fireWater'){ //消防用水
                                    var obj = {},obj1 = {},obj2 = {};
                                    obj.deviceCount = `${res[i].deviceCount}套`;
                                    obj.deviceCounts = res[i].deviceCount;
                                    obj.name = obj2.name = "消防用水";
                                    obj.id = obj1.id = obj2.id = 2;
                                    if(res[i].deviceCount == "0"){
                                        obj.src = require("@/assets/images/riskReport/ys_off.png");
                                        obj1.hint = '消防用水监测设备未安装';
                                        obj1.hintB = '无法对单位消防水压水位情况进行监管，建议根据现场情况加装消防用水监测设备';
                                        this.markedWords.push(obj1);
                                    }else{
                                        obj.src = obj2.src = require("@/assets/images/riskReport/ys_nor.png");
                                        if(res[i].alarmCount <= 20 && res[i].alarmUnhandledCount <= 5){
                                            obj2.reminder = "消防用水安全运行状况良好。"
                                        }else{
                                            obj2.reminder = "消防用水安全运行状况较差，请单位组织排查，加强安全监管。"
                                            obj2.showErr = true;
                                        }
                                        obj2.alarmCount = res[i].alarmCount;
                                        obj2.alarmProcessed = res[i].alarmProcessed;
                                        obj2.alarmProcessing = res[i].alarmProcessing;
                                        obj2.alarmUnhandledCount = res[i].alarmUnhandledCount;
                                        if(res[i].alarmChainIncreaseCount > 0){
                                            obj2.showErr1 = true;
                                            obj2.con = '增长';
                                        }else{
                                            obj2.con = '下降';
                                        }
                                        obj2.alarmChainIncreaseCount = Math.abs(res[i].alarmChainIncreaseCount);
                                        this.analyze.push(obj2);
                                    }
                                    this.condition.push(obj);
                                }else if(i == 'fireHost'){ //独立式探测器
                                    var obj = {},obj1 = {},obj2 = {};
                                    obj.deviceCount = `${res[i].deviceCount}套`;
                                    obj.deviceCounts = res[i].deviceCount;
                                    obj.name = obj2.name = "独立式探测器";
                                    obj.id = obj1.id = obj2.id = 1;
                                    if(res[i].deviceCount == "0"){
                                        obj.src = require("@/assets/images/riskReport/zj_off.png");
                                        obj1.hint = '独立式探测器未接入';
                                        obj1.hintB = '无法对单位火灾报警独立式探测器情况进行监管，建议根据现场情况加装火灾独立式探测器监测设备';
                                        this.markedWords.push(obj1);
                                    }else{
                                        obj.src = obj2.src = require("@/assets/images/riskReport/zj_nor.png");
                                        if(res[i].alarmCount <= 30 && res[i].alarmUnhandledCount <= 10){
                                            obj2.reminder = "独立式探测器监测安全运行状况良好。"
                                        }else{
                                            obj2.reminder = "独立式探测器监测安全运行状况较差，请单位组织排查，加强安全监管。"
                                            obj2.showErr = true;
                                        }
                                        obj2.alarmCount = res[i].alarmCount;
                                        obj2.alarmProcessed = res[i].alarmProcessed;
                                        obj2.alarmProcessing = res[i].alarmProcessing;
                                        obj2.alarmUnhandledCount = res[i].alarmUnhandledCount;
                                        if(res[i].alarmChainIncreaseCount > 0){
                                            obj2.showErr1 = true;
                                            obj2.con = '增长';
                                        }else{
                                            obj2.con = '下降';
                                        }
                                        obj2.alarmChainIncreaseCount = Math.abs(res[i].alarmChainIncreaseCount);
                                        this.analyze.push(obj2);
                                    }
                                    this.condition.push(obj);
                                }else if(i == 'smartElectricity'){ //电气火灾监控系统
                                    var obj = {},obj1 = {},obj2 = {};
                                    obj.deviceCount = `${res[i].deviceCount}套`;
                                    obj.deviceCounts = res[i].deviceCount;
                                    obj.name = obj2.name = "电气火灾监控系统";
                                    obj.id = obj1.id = obj2.id = 0;
                                    if(res[i].deviceCount == "0"){
                                        obj.src = require("@/assets/images/riskReport/yd_off.png");
                                        obj1.hint = '电气火灾监控设备未安装';
                                        obj1.hintB = '无法对单位用电安全隐患情况进行监管，建议根据现场情况加装电气火灾监控设备';
                                        this.markedWords.push(obj1);
                                    }else{
                                        obj.src = obj2.src = require("@/assets/images/riskReport/yd_nor.png");
                                        if(res[i].alarmCount <= 20 && res[i].alarmUnhandledCount <= 5){
                                            obj2.reminder = "单位用电安全运行状况良好。"
                                        }else{
                                            obj2.reminder = "单位用电安全运行状况较差，请单位组织排查，加强安全监管。"
                                            obj2.showErr = true;
                                        }
                                        obj2.alarmCount = res[i].alarmCount;
                                        obj2.alarmProcessed = res[i].alarmProcessed;
                                        obj2.alarmProcessing = res[i].alarmProcessing;
                                        obj2.alarmUnhandledCount = res[i].alarmUnhandledCount;
                                        if(res[i].alarmChainIncreaseCount > 0){
                                            obj2.showErr1 = true;
                                            obj2.con = '增长';
                                        }else{
                                            obj2.con = '下降';
                                        }
                                        obj2.alarmChainIncreaseCount = Math.abs(res[i].alarmChainIncreaseCount);
                                        this.analyze.push(obj2);
                                    }
                                    this.condition.push(obj);
                                }
                            }
                            var compare = function (obj1, obj2) {
                                var val1 = obj1.id;
                                var val2 = obj2.id;
                                if (val1 < val2) {
                                    return -1;
                                } else if (val1 > val2) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            }
                            this.markedWords.sort(compare);
                            this.condition.sort(compare);
                            this.analyze.sort(compare);
                        }else{
                            this.noDate = false;
                        }
                    }
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/risk-report.vue